export function hasValidationErrors (res) {
  return res.validationErrors && res.validationErrors.length
}

export function validationMessage (res) {
  return res.validationErrors[0] && res.validationErrors[0].message
}



// WEBPACK FOOTER //
// ./scripts/src/helpers/api-validation-error.helper.js